<template>
  <div class="historic-records">
    <div class="history-main" v-loading="loading">
      <div class="history-card">
        <div class="history-title flex items-center justify-between">
          <span>历史记录</span>
          <el-select v-model="currentValue" placeholder="请选择" size="small" style="width: 150px" @change="handleTypeChange">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-empty v-if="!historyData || !historyData.length" />
        <div class="history-item flex items-start" v-for="(item,i) in historyData" :key="i" v-else>
          <div class="item-text flex items-center justify-between">
            <div class="flex items-center" style="width: calc(100% - 210px);flex-shrink: 0">
              <span class="icon">
                <img width="17" height="21" :src="require('@/assets/images/GuoJiao/achievement-icon.png')" alt="" v-if="item.type === 'achievement'">
                <img width="18" height="21" :src="require('@/assets/images/GuoJiao/demand-icon.png')" alt="" v-else-if="item.type === 'demand'">
                <img width="21" height="18" :src="require('@/assets/images/GuoJiao/dialog-icon.png')" alt="" v-else>
              </span>
              <p class="text ellipsis">
                <span @click="toDetails(item)" :title="item.title">{{ item.title || '-' }}</span>
              </p>
            </div>
            <span class="item-time">{{ item.createdTime ? formatToDateTime(item.createdTime) : '-' }}</span>
            <span class="delete pointer" @click="handleDelete(item)">
              <img :src="require('@/assets/images/GuoJiao/delete-icon.png')" alt="">
            </span>
          </div>
        </div>
      </div>
      <div class="page-container" v-if="pager.total">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pager.pageNum"
          :page-size="pager.pageSize"
          layout="prev, pager, next"
          :total="pager.total"
        />
      </div>
    </div>
    <!--  确认删除按钮  -->
    <delete-confirm
      :visible.sync="deleteVisible"
      @confirm="handleDeleteConfirm"
      title="提示"
      :message="'删除后，该记录不可恢复。确认删除吗？'"
    />
  </div>
</template>

<script>
import deleteConfirm from '@/components/deleteConfirm.vue';
import { historicRecordsMixin } from '@/mixin/historicRecords/historicRecordsMixin';

export default {
  name: 'historicRecordsGuoJiao',
  mixins: [ historicRecordsMixin ],
  components: {
    deleteConfirm
  },
  props: {},
  data() {
    return {}
  },
  created() {
    document.title = '历史记录';
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    },
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
* {
  font-family: "PingFang SC";
}
.historic-records {
  width: 100%;
  height: 100vh; // // calc(100vh - 62px)
  min-width: 1100px;
  min-height: 100vh; // calc(100vh - 62px)
  max-height: 100vh;
  overflow-y: auto;
  background: #F6F8FD;
  //background: linear-gradient(60.33deg, rgba(207, 234, 255, 0.4) 9%, rgba(227, 227, 255, 0.4) 46%, rgba(192, 223, 255, 0.4) 88%);
  .history-main {
    width: 1080px;
    min-width: 1080px;
    padding: 5px 0 0;
    margin: 0 auto;
    .history-card {
      min-height: 400px;
      padding-bottom: 40px;
      border-radius: 12px;
      background: #fff;
      .history-title {
        height: 60px;
        line-height: 60px;
        font-weight: 500;
        font-size: 18px;
        color: #181F33;
        padding: 0 30px;
        border-bottom: 1px solid #F2F5F9;
        margin-bottom: 14px;
      }
      .history-item {
        margin: 0 30px;
        border-bottom: 1px solid #F2F5F9;
        .item-text {
          width: 100%;
          flex-shrink: 0;
          font-weight: 400;
          font-size: 16px;
          color: #181F33;
          line-height: 16px;
          padding: 20px 0;
          .icon {
            width: 21px;
            height: 21px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 24px;
            .icon-marker {
              flex-shrink: 0;
              width: 14px;
              height: 14px;
              line-height: 14px;
              text-align: center;
              border: 1px solid #eee;
              border-radius: 4px;
              color: #eee;
              font-size: 10px;
            }
          }
          .text {
            width: calc(100% - 100px);
            flex-shrink: 0;
            display: inline-block;
            color: #181F33;
            font-size: 18px;
            font-weight: 400;
            line-height: 26px;
            span {
              cursor: pointer;
            }
          }
        }
        .item-time {
          white-space: nowrap;
          flex-shrink: 0;
          width: 140px;
          font-weight: 400;
          font-size: 16px;
          color: #8191B2;
          padding-left: 20px;
        }
        .delete {
          display: flex;
          align-items: center;
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          margin-left: 30px;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }

    .page-container {
      text-align: center;
      padding: 20px 0;

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #3860F4;
        color: #ffffff;
      }
      /deep/ .el-pagination.is-background .el-pager li {
        font-size: 14px !important;
        border-radius: 4px;
        background-color: #ffffff;
        min-width: 30px;
        height: 28px;
        color: #333333;
        line-height: 28px;
      }
      /deep/ .el-pagination.is-background {
        .btn-next {
          height: 28px;
          line-height: 28px;
          border-radius: 4px;
          background-color: #ffffff;
          .el-icon-arrow-right:before {
            content: '\e791';
          }
        }

        .btn-prev {
          height: 28px;
          line-height: 28px;
          border-radius: 4px;
          background-color: #ffffff;
          .el-icon-arrow-left:before {
            content: '\e792';
          }
        }
      }
    }

    .load-tip {
      text-align: center;
      padding: 20px;
      font-size: 14px;
      color: #777777;
    }
  }
}
</style>
